import { demoProfile } from './demoMode';

/* Restaurant OS demo overlay — makes the Casa Mia demo look fully connected. */

export const isRestDemo = () => {
  try { return sessionStorage.getItem('kx_rest_demo') === '1'; } catch { return false; }
};
export const clearRestDemo = () => { try { sessionStorage.removeItem('kx_rest_demo'); } catch { /* noop */ } };

const EARNED = ['toast', 'google_business', 'doordash', 'ubereats', 'opentable', 'instagram', 'email_marketing', 'yelp', 'grubhub', 'manual_imports', 'csv'];

export const DEMO_GBP_STATUS = {
  gbp: {
    status: 'connected',
    google_email: 'owner@casamia-demo.com',
    location: 'Casa Mia Trattoria',
    connected_by: 'Owner',
    connected_at: '2026-06-02T10:00:00Z',
    last_sync: new Date(Date.now() - 45 * 60000).toISOString(),
  },
  gbp_snapshot: { rating: 4.7, review_count: 318 },
};

export function overlayRestDemo(path, json) {
  const clean = path.split('?')[0];
  if (clean === '/connections' && json?.connections) {
    const conns = json.connections.map((c) =>
      EARNED.includes(c.key) ? { ...c, earned: true, status: 'connected' } : c);
    const max = json.score?.max || 100;
    const value = Math.min(max, conns.filter((c) => c.earned).reduce((s, c) => s + (c.points || 0), 0));
    return { ...json, connections: conns, score: { ...(json.score || {}), value, max } };
  }
  if (clean === '/me' && json?.role === 'demo' && json?.user) {
    const p = demoProfile();
    return { ...json, user: { ...json.user, name: p.name || 'Chef' } };
  }
  return json;
}
